import { FC, useState } from 'react';
import styled from '@emotion/styled';
import IcBubbleArrowBase from 'src/assets/images/icBubbleArrowDown.svg';
import IcHelpBase from 'src/assets/images/icHelp.svg';
import { mouseHoverCss } from 'src/utils/styled';
const Wrap = styled.div`
  position: relative;
`;
const SpeechBubble = styled.div`
  position: absolute;
  top: -16px;
  ${({
  theme
}) => theme.isRtl ? 'left' : 'right'}: -19.5px;
  transform: translateY(-100%);

  width: max-content;
  max-width: 343px;
  padding: 16px;
  border-radius: 16px;

  background-color: ${({
  theme
}) => theme.color.surface12};
  color: ${({
  theme
}) => theme.color.content12Fixed};
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  white-space: pre-wrap;

  ${mouseHoverCss(`
    cursor: pointer;
  `)};

  ${({
  theme
}) => theme.screenSize.mobile} {
    line-height: 16.71px;
    ${({
  theme
}) => theme.isRtl ? 'left' : 'right'}: -32px;
    max-width: 328px;
  }
`;
const IcBubbleArrow = styled(IcBubbleArrowBase)`
  position: absolute;
  top: -16px;
  left: 50%;
  transform: translateX(-50%);

  width: 14px;
  height: 11px;
`;
const TooltipToggleButton = styled.button`
  all: unset;
  width: 16px;
  height: 16px;
  position: relative;
  ${mouseHoverCss(`
    cursor: pointer;
  `)};
`;
const IcHelp = styled(IcHelpBase)`
  width: 100%;
  height: 100%;
  flex-shrink: 0;
`;
interface Props {
  tooltipMessage: string;
}
const HelpIconWithTooltip: FC<Props> = ({
  tooltipMessage
}) => {
  const [isShowTooltip, setIsShowTooltip] = useState(false);
  return <Wrap data-sentry-element="Wrap" data-sentry-component="HelpIconWithTooltip" data-sentry-source-file="HelpIconWithTooltip.tsx">
      {isShowTooltip && <>
          <SpeechBubble onClick={() => setIsShowTooltip(false)} role='button' tabIndex={0}>
            {tooltipMessage}
          </SpeechBubble>
          <IcBubbleArrow />
        </>}
      <TooltipToggleButton onClick={() => setIsShowTooltip(prev => !prev)} data-sentry-element="TooltipToggleButton" data-sentry-source-file="HelpIconWithTooltip.tsx">
        <IcHelp data-sentry-element="IcHelp" data-sentry-source-file="HelpIconWithTooltip.tsx" />
      </TooltipToggleButton>
    </Wrap>;
};
export default HelpIconWithTooltip;